import { isAcceptanceTest } from 'hub-http/helpers/env';
import { useMemo, useRef } from 'react';
import { useAsyncBulkGetQuizMeQuery } from '../../../../__generated__/chirp/com/hubspot/academy/gen/ai/skills/rpc/QuizMeRpc.hooks';
import { useQuizMeSession } from '../utils/quizMeUtils';
import { shuffleTaskAnswers } from '../utils/contentUtils';
import { useLessonQuizMeVideoRequestParams } from './useLessonQuizMe';
export const useLessonQuizMeFromCache = ({
  contents,
  lessonContentId
}) => {
  const shuffledCacheRef = useRef({
    correlationId: undefined,
    result: undefined
  });
  const {
    getQuizState
  } = useQuizMeSession();
  const {
    requestParams
  } = useLessonQuizMeVideoRequestParams({
    contents
  });
  const taskIds = useMemo(() => (requestParams || []).reduce((acc, {
    lessonContentId: id
  }) => {
    var _getQuizState;
    const task = (_getQuizState = getQuizState(id, 'LESSON')) === null || _getQuizState === void 0 ? void 0 : _getQuizState.tasks;
    if (task) {
      acc.push(task);
    }
    return acc;
  }, []), [requestParams, getQuizState]);
  const {
    data
  } = useAsyncBulkGetQuizMeQuery({
    fetchPolicy: 'cache-only',
    variables: {
      taskIds
    },
    skip: isAcceptanceTest() || taskIds.length === 0
  });
  const quizMeData = useMemo(() => {
    var _task$quizResponse;
    const state = lessonContentId ? getQuizState(lessonContentId, 'LESSON') : undefined;
    const contentTaskId = state === null || state === void 0 ? void 0 : state.tasks;
    const taskIndex = contentTaskId ? taskIds.indexOf(contentTaskId) : -1;
    const task = taskIndex >= 0 ? data === null || data === void 0 ? void 0 : data.tasks[taskIndex] : undefined;
    const correlationId = task === null || task === void 0 || (_task$quizResponse = task.quizResponse) === null || _task$quizResponse === void 0 ? void 0 : _task$quizResponse.correlationId;
    const cached = shuffledCacheRef.current;
    if (!correlationId) {
      return task;
    }
    if (correlationId === cached.correlationId) {
      return cached.result;
    }
    const shuffled = shuffleTaskAnswers(task);
    shuffledCacheRef.current = {
      correlationId,
      result: shuffled
    };
    return shuffled;
  }, [data, taskIds, lessonContentId, getQuizState]);
  return quizMeData;
};